import { lazy } from "react";

const Attendance = lazy(() => import("../Component/Employee/Attendance"));
const ManageLeave = lazy(() => import("../Component/Employee/ManageLeave"));
const VacancyList = lazy(() => import("../Component/Employee/VacancyList"));
const AddExpense = lazy(() => import("../Component/Employee/AddExpence"));
const LeadersOfHub = lazy(() => import("../Component/Employee/LeadersOfHub"));

const employeeRoutes = [
  { path: "/manage-attendance", element: <Attendance />, protected: true },
  { path: "/manage-leave", element: <ManageLeave />, protected: true },
  { path: "/vacancy-list", element: <VacancyList />, protected: true },
  { path: "/add-expense", element: <AddExpense />, protected: true },
  { path: "/leader-of-hub", element: <LeadersOfHub />, protected: true },
];

export default employeeRoutes;
